import Api from "lib/Api";

export function sendWeeklyReport() {
  return () =>
    Api.get("/send_weekly_report", {
      parseResponse: false,
      withoutOrganization: true,
    });
}
